import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  CART_ITEM_LIST_BLOCK_DATA_SOURCE,
  CartItemListBlockDataSource,
} from './cart-item-list-block-view-model';
import { CartItemListBlockPreviewDataSource } from './cart-item-list-block-preview-data-source';
import { CartItemListBlockStoreDataSource } from './cart-item-list-block-store-data-source';

export function provideCartItemListBlockDataSource(): Provider[] {
  return [
    CartItemListBlockStoreDataSource,
    CartItemListBlockPreviewDataSource,
    {
      provide: CART_ITEM_LIST_BLOCK_DATA_SOURCE,
      useFactory: (): CartItemListBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(CartItemListBlockPreviewDataSource)
          : inject(CartItemListBlockStoreDataSource);
      },
    },
  ];
}
